import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ChevronRight } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

/**
 * Breadcrumb navigation shown at the top of sub-pages.
 * items: [{ to: '/', label: 'Inicio' }, { to: null, label: 'Qué Hacemos' }, ...]
 * The last item is the current page (no link).
 */
const Breadcrumb = ({ items = [] }) => {
  const { lang } = useLanguage();
  const homeLabel = lang === 'en' ? 'Home' : 'Inicio';

  const trail = [{ to: '/', label: homeLabel, icon: Home }, ...items];

  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumb"
      className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12 pt-28 pb-2"
    >
      <ol className="flex flex-wrap items-center gap-x-1.5 gap-y-2 text-xs text-white/50">
        {trail.map((item, i) => {
          const isLast = i === trail.length - 1;
          const Icon = item.icon;
          return (
            <li key={i} className="inline-flex items-center gap-1.5">
              {isLast ? (
                <span
                  className="inline-flex items-center gap-1.5 text-amber-300/80 font-medium"
                  aria-current="page"
                  data-testid="breadcrumb-current"
                >
                  {Icon && <Icon className="w-3.5 h-3.5" />}
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.to}
                  data-testid={`breadcrumb-link-${i}`}
                  className="inline-flex items-center gap-1.5 hover:text-amber-300 transition-colors"
                >
                  {Icon && <Icon className="w-3.5 h-3.5" />}
                  {item.label}
                </Link>
              )}
              {!isLast && <ChevronRight className="w-3 h-3 text-white/25" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
